// Shared category slug utility - single source of truth for all category URL slugs

export function categoryToSlug(category: string): string {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const CATEGORY_SLUG_MAP: Record<string, string> = {
  // 7 Consolidated Core Pillars
  "systems-architecture": "Systems Architecture",
  "revenue-operations": "Revenue Operations",
  "artificial-intelligence": "Artificial Intelligence",
  "automation-strategy": "Automation Strategy",
  "hiring-strategy": "Hiring Strategy",
  "agency-scaling": "Agency Scaling",
  "compensation-and-logistics": "Compensation & Logistics",

  // Backwards-compatible aliases for legacy slugs
  "crm-architecture": "Systems Architecture",
  "data-architecture": "Systems Architecture",
  "sales-systems": "Revenue Operations",
  "conversion-optimization": "Revenue Operations",
  "ai-voice-automation": "Artificial Intelligence",
  "agentic-ai": "Artificial Intelligence",
  "advanced-automation": "Automation Strategy",
  "hiring-guide": "Hiring Strategy",
  "management-and-tracking": "Agency Scaling",
  "infrastructure-scaling": "Agency Scaling",
  "ghl-for-filipino-vas": "Hiring Strategy",
};

// Find related categories by shared tags (not alphabetical)
export function getRelatedCategories(
  currentCategory: string,
  allPosts: { category: string; tags?: string[] }[],
  count: number = 2,
): string[] {
  const currentPosts = allPosts.filter((p) => p.category === currentCategory);
  const currentTags = new Set<string>();
  currentPosts.forEach((p) => p.tags?.forEach((t) => currentTags.add(t)));

  const otherCategories = Array.from(
    new Set(allPosts.map((p) => p.category)),
  ).filter((c) => c !== currentCategory);

  const scored = otherCategories.map((cat) => {
    const catPosts = allPosts.filter((p) => p.category === cat);
    const catTags = new Set<string>();
    catPosts.forEach((p) => p.tags?.forEach((t) => catTags.add(t)));
    let overlap = 0;
    currentTags.forEach((t) => {
      if (catTags.has(t)) overlap++;
    });
    return { category: cat, overlap };
  });

  // Sort by tag overlap descending, then by post count descending as tiebreaker
  scored.sort((a, b) => {
    if (b.overlap !== a.overlap) return b.overlap - a.overlap;
    const aCount = allPosts.filter((p) => p.category === a.category).length;
    const bCount = allPosts.filter((p) => p.category === b.category).length;
    return bCount - aCount;
  });

  return scored.slice(0, count).map((s) => s.category);
}
